import { getField } from 'vuex-map-fields'

export const getters = {
  getField,
}
